import React from "react";
import { useTranslation } from "react-i18next";
import tw from "tailwind-styled-components";
import PlaceIcon from "@mui/icons-material/Place";
import "../../App.css";
import countryCode from "./../../countryCode/index.json";

const SearchInput = ({
  value,
  country,
  setShow,
  setSearch,
  goToSearch,
  selectedDate,
}) => {
  const { t } = useTranslation("common");

  const navigateToSearch = (e) => {
    e?.stopPropagation();
    goToSearch("text");
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      navigateToSearch();
    }
  };

  return (
    <ContainerInner>
      <div
        className="flex w-full h-full items-center rounded-s-full"
        onClick={setShow}
      >
        {countryCode[country?.toLowerCase()] && (
          <div className="w-[40px] ml-1 pl-1">
            <img
              src={`https://flagcdn.com/w40/${
                countryCode[country?.toLowerCase()]
              }.png`}
              srcSet={`https://flagcdn.com/w80/${
                countryCode[country?.toLowerCase()]
              }.png 2x`}
              className="w-[40px] h-[20px]"
            />
          </div>
        )}
        <PlaceIcon className="text-buttonColor self-center mr-1" />
        <input
          value={value}
          className={Input}
          placeholder={t("header.search_Placeholder")}
          onChange={setSearch}
          onKeyDown={handleKeyPress}
          autoComplete="off"
          role="presentation"
        />
      </div>
    </ContainerInner>
  );
};

const Container = tw.div`
w-full 
flex 
`;

const ContainerInner = tw.div`
w-full
flex
h-[54px] 
bg-white
shadow-[0_0px_20px_0px_#00000054]
rounded-full
pl-2
`;

const Input = `
lg2:w-[600px] lg-[580px]  md2:w-[460px] md:w-[400px] sm:w-[360px] xsm:w-[290px] w-[100%]
h-full 
text-blackText
font-sans
text-[16px] 
focus:outline-none 
focus:border-[gray] 
placeholder:text-gray-400
rounded-r-full
px-3
`;

export default SearchInput;
